<script setup>
import { useVModel } from '#/general/useVModel'
const props = defineProps(['value', 'label', 'optionValue', 'boolean'])
defineEmits(['update:value'])
const value = useVModel(props, 'value')

function clicked () {
  if (props.boolean) {
    value.value = !value.value
  } else {
    value.value = props.optionValue
  }
}
</script>

<template lang="pug">
.widgetCheckboxContainer(@click="clicked")
  .checkbox(:class="value === optionValue ? 'selected' : ''")
    .checkbox-svg
      svg(width='15' height='11' viewBox='0 0 15 11' fill='none' xmlns='http://www.w3.org/2000/svg' v-if="value === optionValue")
        path(d='M4.76691 8.6786L1.21092 5.25802L0 6.41462L4.76691 11L15 1.1566L13.7976 0L4.76691 8.6786Z' fill='#22223C')
  .label
    span(v-if="label") {{ label }}
    slot(v-else)
</template>

<style scoped lang="sass">
.widgetCheckboxContainer
  display: flex
  flex-direction: row
  cursor: pointer
  align-items: center
  margin-bottom: 18px
  border: 2px solid transparent
  .checkbox
    min-width: 24px
    min-height: 24px
    width: 24px
    height: 24px
    border-radius: 5px
    transition: all 0.3s ease
    border: 2px solid white
  .selected
    background: #70FFD0
    display: flex
    justify-content: center
    align-items: center
  .label
    flex: 1
    padding-left: 14px
    font-weight: 500
    font-size: 16px
    line-height: 130%
    color: white

</style>
